const init = () => {
    const TERM_SELECTOR = '#categories';
    const TERM2_SELECTOR = '#diseases';
    const WRAPPER_SELECTOR = '#wrapper-title-cards';
    const TYPE = '#type';
    const LANG = '#lang';

    const $term = $(TERM_SELECTOR);
    const $term2 = $(TERM2_SELECTOR);
    const $wrapper = $(WRAPPER_SELECTOR);
    const $type = $(TYPE);
    const $lang = $(LANG);

    $term.on('changed.bs.select', function(){
        getElements();
    });

    $term2.on('changed.bs.select', function(){
        getElements();
    })

    const getElements = async() => {
        const url = `${window.location.origin}/${$type.val()}/category/?term=${$term.val()}
            &term2=${$term2.val()}&lang=${$lang.val()}`;
        const getData = await fetch(url);
        const data = await getData.json();
        renderView(data);
    }

    const renderView = (data) => {
        const cards = data;

        let innerHtml = '';

        const loadingHtml = `
            <div class="col-12 d-flex flex-wrap justify-content-center">
                <img src="${$wrapper.data('loading')}" alt="cargando...">
            </div>
        `;

        $wrapper.html(loadingHtml);

        cards.map(card => {
            innerHtml += `
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="card-background position-relative d-flex align-items-end">
                        <div class="card-background__image" style="background-image: url(${card.image})"></div>
                        <div class="card-background__color"></div>
                        <div class="card-background__content position-relative">
                            <h6 class="d-flex align-items-center"><i class="material-icons">date_range</i>${card.date}</h6>
                            <h3>${card.title}</h3>
                            <span class="d-flex align-items-center">Ver más <i class="material-icons">chevron_right</i></span>
                        </div>
                        <a href="${card.url}" class="card-background__url"></a>
                    </div>
                </div>
            `
        });

        const emptyHtml = `
            <div class="col-12 d-flex flex-wrap justify-content-center">
                <h3>No hemos encontrado resultados para los filtros seleccionados, por favor seleccione otra opción</h3>
            </div>
        `;

        innerHtml ? $wrapper.html(innerHtml) : $wrapper.html(emptyHtml);

    }

}

export default {
    init
}